var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewClientRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1983_20520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1983_20520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1983_20520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99795 10.9998C11.2847 10.9998 12.3279 9.95662 12.3279 8.6698C12.3279 7.38298 11.2847 6.33984 9.99795 6.33984C8.71115 6.33984 7.66797 7.38298 7.66797 8.6698C7.66797 9.95662 8.71115 10.9998 9.99795 10.9998Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.6594C14 14.8594 12.21 13.3994 10 13.3994C7.79 13.3994 6 14.8594 6 16.6594",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4674 11.7998V10.1331C17.4674 10.0447 17.4323 9.95995 17.3698 9.89744C17.3073 9.83492 17.2225 9.7998 17.1341 9.7998C17.0457 9.7998 16.9609 9.83492 16.8984 9.89744C16.8359 9.95995 16.8008 10.0447 16.8008 10.1331V11.7998H15.1341C15.0457 11.7998 14.9609 11.8349 14.8984 11.8974C14.8359 11.9599 14.8008 12.0447 14.8008 12.1331C14.8008 12.2215 14.8359 12.3063 14.8984 12.3688C14.9609 12.4314 15.0457 12.4665 15.1341 12.4665H16.8008V14.1331C16.8008 14.2215 16.8359 14.3063 16.8984 14.3688C16.9609 14.4314 17.0457 14.4665 17.1341 14.4665C17.2225 14.4665 17.3073 14.4314 17.3698 14.3688C17.4323 14.3063 17.4674 14.2215 17.4674 14.1331V12.4665H19.1341C19.2225 12.4665 19.3073 12.4314 19.3698 12.3688C19.4323 12.3063 19.4674 12.2215 19.4674 12.1331C19.4674 12.0447 19.4323 11.9599 19.3698 11.8974C19.3073 11.8349 19.2225 11.7998 19.1341 11.7998H17.4674Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1983_20520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClientRequest);
export default __webpack_public_path__ + "static/media/new_client_request.98a4b6e0e44fc9541d70a5d0f4e911f3.svg";
export { ForwardRef as ReactComponent };